// ai/* 페이지 번역
const ai = {
  aiAnalysis: {
    newChat: '새 대화',
    send: '전송',
    file: {
      excel: 'Excel 파일',
      csv: 'CSV 파일',
      pdf: 'PDF 파일',
      file: '파일',
      rows: '({n}건)',
      download: '다운로드',
      ready: '데이터 준비됨',
    },
    title: 'AI 분석',
    welcome: '안녕하세요! AI 분석 도우미입니다. 사출 설비 데이터, 생산 현황, 알람 분석 등에 대해 질문해주세요.',
    welcomeMatch: '안녕하세요! AI 분석 도우미입니다',
    noResponse: '응답을 받지 못했습니다.',
    errorMessage: '죄송합니다. 메시지를 처리하는 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
    assistant: 'AI 어시스턴트',
    user: '사용자',
    suggestionsTitle: '추천 질문',
    placeholder: '질문을 입력하세요... (Shift+Enter로 줄바꿈)',
    suggestions: {
      qualityDefectTrend: '최근 불량률 추이를 선그래프로 보여줘',
      qualityTopAlarmEquip: '오늘 품질 알람이 가장 많이 발생한 설비는?',
      qualityTempAnalysis: '사출 1호기의 최근 온도 변화에 대해서 분석해줘',
      qualityDefectByEquip: '최근 7일간 설비별 불량 발생 현황을 막대그래프로 보여줘',
      productionRunningEquip: '현재 가동 중인 설비 현황은?',
      productionTopOutput: '오늘 생산량이 가장 많은 설비는?',
      productionTrend: '최근 7일간 생산량 추이를 선그래프로 보여줘',
      productionUtilizationCompare: '설비별 가동률을 비교해줘',
      maintenanceTopAlarm: '오늘 알람이 가장 많이 발생한 설비는?',
      maintenanceAlarmTrend: '최근 7일간 설비별 알람 발생 추이를 보여줘',
      maintenanceCycleTimeAnalysis: '사출 1호기의 최근 사이클 타임 변화를 분석해줘',
      maintenanceIdleEquip: '현재 비가동 설비 현황은?',
      defaultRunningEquip: '현재 가동 중인 설비 현황은?',
      defaultTopAlarm: '오늘 알람이 가장 많이 발생한 설비는?',
      defaultTrend: '최근 7일간 생산량 추이를 선그래프로 보여줘',
      defaultShotTempAnalysis: '사출 1호기에 최근 샷 온도 변화에 대해서 분석해줘',
    },
  },
  labelReview: {
    stage: {
      collect: '수집',
      inspect: '품질 검사',
      label: '자동 라벨',
      verify: '신뢰도 검증',
      drift: '드리프트',
      retrain: '재학습'
    },
    stageNote: {
      collect: '오늘 공정 샷',
      inspect: '공정·비전·융합 판정',
      label: '라벨 부여',
      verify: '확정 · 검토 대기 {n}',
      drift: '1σ 이상 설비 / {n}대',
      retrain: '열린 요청 · 학습셋 {n}'
    },
    stageHint: {
      collect: '라벨링 대상 설비의 오늘 공정 샷 수',
      inspect: '세 검사 결과가 모두 모인 샷 (융합 판정 완료)',
      label: '자동 라벨이 붙은 샷',
      verify: '자동 확정 + 작업자 확정. 신뢰도 미달은 검토 대기',
      drift: '최근 시간 평균 점수가 기준 분포에서 1σ 이상 벗어난 설비',
      retrain: '처리 중인 재학습 요청 수 (학습셋 1,000건 → 이후 100건마다, 드리프트, 일치율 저하)'
    },
    agreeTitle: '자동 라벨 일치율',
    agreeNote: '감사 표본 {n}건 · 목표 {target}% (1,000건)',
    agreeHint: '자동 확정분 무작위 2%를 작업자가 확인한 결과 — 성과지표',
    queueTitle: '검토 대기열',
    queueSub: '{n}건 · 감사 표본 {a}건',
    allEquipment: '전체 설비',
    emptyQueue: '검토할 샷이 없습니다',
    doneN: '이번에 확정 {n}건',
    pickOne: '왼쪽 대기열에서 샷을 고르세요',
    shotN: '샷 #{n}',
    trendTitle: '직전 20샷 점수 추이',
    sigmaLine: '양품 3σ 상한',
    noTrend: '추이 데이터 없음',
    decideTitle: '작업자 확정',
    autoLabel: '자동 라벨',
    choice: {
      OK: '양품',
      FLASH: '버',
      WELDLINE: '웰드라인',
      SHORT: '미성형',
      SINK: '수축',
      PROCESS: '불량 (공정 기인)',
      SKIP: '보류 (판단 불가)'
    },
    saved: '샷 #{shot} → {label} 확정',
    saveFailed: '저장하지 못했습니다. 다시 시도해 주세요',
    keysNote: '단축키 1~6 · S 보류 · ←/→ 이동. 확정 라벨은 일치율 · 융합 가중치 학습 · 재학습 학습셋에 쓰입니다.',
    requestsTitle: '재학습 요청',
    noRequests: '아직 요청이 없습니다',
    cases: '건',
    kind: {
      PROCESS: '공정 AI',
      VISION: '비전 AI',
      FUSION: '융합 가중치',
      ALL: '전체'
    },
    reason: {
      BATCH: '학습셋 1,000건',
      INCREMENTAL: '학습셋 +100건',
      DRIFT: '드리프트',
      ACCURACY: '일치율 저하',
      FUSION_TUNE: '확정 라벨 +200건'
    },
    reqStatus: {
      REQUESTED: '요청',
      TRAINING: '학습 중',
      DONE: '완료',
      REJECTED: '반려'
    }
  },
  aiManage: {
    addBtn: '모델 연결 추가',
    tabs: { connections: '모델 연결', calls: '호출 이력' },
    provider: { OPENAI_COMPATIBLE: 'OpenAI 호환 (DGX·LM Studio 등)', ANTHROPIC: 'Anthropic Claude' },
    feature: {
      CHAT_SQL: 'AI 분석 · 질문 해석·SQL 생성 (도구 호출)',
      CHAT_ANSWER: 'AI 분석 · 답변 작성',
      ANALYSIS: 'AI 분석 · 데이터 분석 에이전트',
      VISUALIZATION: 'AI 분석 · 차트 생성',
      REPORT: '보고서 · 일/주/월 보고서·알람 분석·개선 제안',
    },
    featureShort: { CHAT_SQL: 'SQL 생성', CHAT_ANSWER: '답변 작성', ANALYSIS: '분석', VISUALIZATION: '차트', REPORT: '보고서' },
    connections: {
      title: '모델 연결',
      help: '챗봇·보고서가 쓰는 LLM 연결입니다. 키는 암호화해 저장되고 화면에 다시 표시되지 않습니다. 키를 비우면 서버 환경변수(OPENAI_API_KEY / ANTHROPIC_API_KEY)를 씁니다.',
      empty: '등록된 모델 연결이 없습니다.',
    },
    card: {
      active: '사용', inactive: '중지', keySaved: '키 저장됨', keyEnv: '환경변수 키', keyNone: '키 없음',
      workspace: '워크스페이스', testFailed: '연결 실패 — 아래 오류 원문을 확인하세요', errorDetail: '오류 원문 보기',
      noFeatures: '배정된 기능 없음', test: '테스트', testing: '테스트 중…', edit: '수정', delete: '삭제',
      deleteBlocked: '배정된 기능이 있어 삭제할 수 없습니다. 먼저 배정을 바꾸세요.',
    },
    assign: {
      title: '기능별 모델 배정',
      help: '기능마다 어느 연결을 쓸지 고릅니다. 바꾸면 다음 호출부터 바로 적용됩니다. 미배정이면 첫 번째 사용 중 연결을 씁니다.',
      feature: '기능', connection: '모델 연결', updated: '변경', none: '(미배정 · 첫 연결 사용)',
    },
    form: {
      addTitle: '모델 연결 추가', editTitle: '모델 연결 수정',
      connKey: '연결 키', name: '이름', provider: '제공자', apiBase: 'API 주소', modelName: '모델',
      loadModels: '모델 목록 불러오기', modelsLoaded: '모델 {n}개를 불러왔습니다. 입력란에서 고를 수 있습니다.', noModels: '모델 목록이 비어 있습니다.',
      apiKey: 'API 키', apiKeyKeep: '비우면 저장된 키를 유지합니다', apiKeyEnv: '비우면 서버 환경변수 키를 씁니다', clearKey: '저장된 키 삭제',
      workspaceId: '워크스페이스 ID (선택)', workspaceHint: '워크스페이스에 묶이지 않은 키(sk-ant-usr…)를 쓸 때만 입력합니다. Claude Console 의 워크스페이스 ID(wrkspc_…)',
      timeoutMs: '타임아웃(ms)', maxTokens: '최대 토큰', temperature: 'temperature', effort: 'effort (사고 깊이)',
      sortOrder: '정렬', isActive: '사용 여부', description: '설명', default: '기본값',
      anthropicHint: 'Claude 5.x 는 temperature 를 받지 않고 effort 로 사고 깊이를 조절합니다. 채팅은 low 가 빠릅니다.',
      required: '연결 키·이름·모델은 필수입니다.',
    },
    calls: {
      title: '최근 호출 100건', todayCalls: '오늘 호출', todayTokens: '오늘 토큰', monthCalls: '이번 달 호출', monthTokens: '이번 달 토큰',
      monthFailures: '이번 달 실패', avgLatency: '평균 응답', byConnection: '이번 달 연결별',
      time: '시각', feature: '기능', connection: '연결', model: '모델', tenant: '사업장', inTokens: '입력 토큰', outTokens: '출력 토큰',
      latency: '응답(ms)', result: '결과', failed: '실패', empty: '호출 이력이 없습니다.',
    },
    msg: { saved: '저장했습니다.', deleted: '삭제했습니다.', assigned: '배정을 바꿨습니다.', confirmDelete: "'{name}' 연결을 삭제할까요?" },
  },
};

export default ai;
